import { useState } from 'react'
import Snippet from '../../components/Snippet/Snippet'
import { template, toggle } from '../../assets/code-snippets/navigation/template'
import Modal from '../../components/Modal/Modal'

const Navigation = () => {

    const [modal, setModal] = useState({
        display: !1,
        cssClass: 'xl top1',
        scroll: !0,
        header: '<h1>JS 4 mobile toggling</h1>',
        footer: '<h3 class="text right">JS 4 mobile toggling</h3>'
    })

    const toggleModal = () => {
        setModal(prev => ({
            ...prev,
            display: !prev.display
        }))
    }
    const [templateModal, setTemplateModal] = useState({
        display: !1,
        cssClass: 'xl top0',
        scroll: !0,
        header: '<h1>NAVIGATIONAL ELEMENT</h1>',
        footer: '<h3 class="text right">Navigation Template Snippet</h3>'
    })

    const toggleTemplateModal = () => {
        setTemplateModal(prev => ({
            ...prev,
            display: !prev.display
        }))
    }


    return <div className='container fluid py-2'>

        <Modal structure={templateModal} onToggle={toggleTemplateModal}>
            <Snippet code={template} language='html' />
        </Modal>
        <Modal structure={modal} onToggle={toggleModal}>
            <Snippet code={toggle} language='html' />
        </Modal>

        <div className="container xl">
            <p className="text xl primary"><a href="#intro" className="link">&#128279;</a> Navigation by POKE-CSS </p>
            <p className="text md">  <button className='btn lg primary' onClick={toggleTemplateModal}>Navigation</button> in POKE-CSS is purely created using raw HTML & SCSS, in order to keep the mobile
            navigation in working order a bit of JavaScript code is required to toggle the nav, which can be previewed by pressing <button className='btn lg primary' onClick={toggleModal}>mobile-nav js</button>.</p>
        </div>

        <div className='spacer md'></div>

        <div className="container fluid">
            <p className="text xl primary">Doc Table</p>
            <div className="table" table-striped="true" cell-spacing="1" padding="3">
                <table>
                    <thead>
                        <tr>
                            <th>Parent class</th>
                            <th>Additional class</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>.nav</td>
                            <td><code>.sm, .md, .lg, .xl, .xxl</code></td>
                            <td><p className="text danger bold">Necessary!</p> Will display hamburger menu + mobile navigation on specific client width</td>
                        </tr>
                        <tr>
                            <td>.nav</td>
                            <td><code>.color-light, .color-dark, .color-success, .color-primary, .color-info, .color-danger, .color-secondary, .color-warning</code></td>
                            <td>Will set text and links color for the entire navigation</td>
                        </tr>
                        <tr>
                            <td>.nav</td>
                            <td><code>.light, .dark, .success, .primary, .info, .danger, .secondary, .warning</code></td>
                            <td>Will set background color + color for the entire navigation</td>
                        </tr>
                        <tr>
                            <td>.nav</td>
                            <td><code>.around</code></td>
                            <td>Will apply <code>justify-content: space-around</code> to navigational links</td>
                        </tr>
                        <tr>
                            <td>.nav</td>
                            <td><code>.between</code></td>
                            <td>Will apply <code>justify-content: space-between</code> to navigational links</td>
                        </tr>
                        <tr>
                            <td>.nav</td>
                            <td><code>.sticky</code></td>
                            <td>Will apply <code>position: sticky; top: 0;</code> to poke-nav element</td>
                        </tr>
                        <tr>
                            <td>.nav</td>
                            <td><code>mobile-fullscreen</code></td>
                            <td>Will force mobile navigation on fullscreen once active</td>
                        </tr>
                        <tr>
                            <td>.nav</td>
                            <td><code>mobile-active</code></td>
                            <td>Will display the mobile navigation</td>
                        </tr>
                        <tr>
                            <td><code>.nav-link</code></td>
                            <td><code>.active</code></td>
                            <td>Will mark nav link as active</td>
                        </tr>
                        <tr>
                            <td><code>.nav/</code></td>
                            <td><code>ul.nav-list.right</code></td>
                            <td>When creating another list in main navigation can be used to display this to the right side of the screen</td>
                        </tr>
                        <tr>
                            <td><code>.nav/div.mobile/ul.mobile-list/li.dropdown</code></td>
                            <td><code>.expanded</code></td>
                            <td>Will expand mobile nav dropdown</td>
                        </tr>
                        <tr>
                            <td>body</td>
                            <td><code>.nav-active</code></td>
                            <td> Will set <code>overflow-y: hidden;</code> property to body element to prevent scrolling </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="container fluid py-2">
            <span className="badge xl warning gradient">NAVIGATIONAL ELEMENT</span>
            <Snippet code={template} language='html' />
        </div>

    </div>
}

export default Navigation